import { UseFormReturn } from 'react-hook-form'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { FormInput } from 'src/shared/components/FormComponents'
import type { SignupSuccessFormData } from '../types'

interface PersonalInformationSectionProps {
  methods: UseFormReturn<SignupSuccessFormData>
}

export const PersonalInformationSection = ({
  methods,
}: PersonalInformationSectionProps) => {
  return (
    <Column className="gap-4">
      <h2>Personal</h2>

      <Row className="gap-4">
        <FormInput
          label="First name"
          name="firstName"
          methods={methods}
          className="w-full"
        />
        <FormInput
          label="Last name"
          name="lastName"
          methods={methods}
          className="w-full"
        />
      </Row>
    </Column>
  )
}
